export default __webpack_public_path__ + "static/media/avail-fs8.d7fa5382.png";